<template>
  <div class="recalculate-costs-modal">
    <h3 class="title">{{ $t('atualiza_custos_titulo') }}</h3>

    <div v-if="loading" class="loading-container">
      <i class="fas fa-spinner fa-spin"></i>
      <p>{{ $t('atualiza_custos_gerando') }}</p>
    </div>

    <template v-else>
      <div class="data-form">
        <div class="field half">
          <label for="DTREFECUSTO">{{$t('reference_date')}}:</label><br>
          <input
            id="DTREFECUSTO"
            type="date"
            v-model="formData.DTREFECUSTO"
          />
        </div>

        <div class="field half">
          <label for="costType">{{$t('cost_type')}}</label>
          <br />
          <v-select
            id="costType"
            v-model="formData.costType"
            :options="formData.costTypeOptions"
            label="NMTIPOCUSTO"
            :append-to-body="true"
            @search="onSearchCostType"
          ></v-select>
        </div>
      </div>

      <div class="buttons-container">
        <div
          v-if="existingCustoUpdateReport"
          class="button ghost"
          id="open-report"
          @click="openExistingReport"
        >{{ $t('custo_update_report_abrir') }}</div>
        <div class="button" id="cancel" @click="cancel">{{$t('cancel')}}</div>
        <div class="button" id="confirm" @click="confirm">{{$t('confirm')}}</div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import { t } from 'i18next';
import Util from "@/application/libs/util";
import RegisteredDataController from "../../controllers/RegisteredDataController";
import RecalculateCostsController from "../../controllers/RecalculateCostsController";
import CustoUpdateReportModal from "./CustoUpdateReportModal";

export default {
  name: "RecalculateCostsModal",
  components: { "v-select": vSelect },
  props: {
    cardData: { type: Object, required: true },
    nrcenario: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      formData: {
        DTREFECUSTO: null,
        costTypeOptions: [],
        costType: null
      }
    };
  },
  computed: {
    existingCustoUpdateReport() {
      const report = this.cardData?.dataCatalog?.custoUpdateReport;
      if (!report || typeof report !== 'object' || Array.isArray(report)) return null;
      return Object.keys(report).length ? report : null;
    }
  },
  mounted() {
    const filter = Util.getFilterInSession();

    this.formData.DTREFECUSTO = filter.DTREFECUSTO
      ? moment(filter.DTREFECUSTO, 'DD/MM/YYYY').format('YYYY-MM-DD')
      : null;

    RegisteredDataController.searchCostType(null, () => {}, this).then(() => {
      const options = this.formData.costTypeOptions || [];
      this.formData.costType =
        options.find(o => String(o.CDTIPOCUSTO) === String(filter.NRTIPOCUSTO)) ||
        (options.length ? options[0] : null);
    });
  },
  methods: {
    onSearchCostType: Util.debounce(function(search, loading) {
      return RegisteredDataController.searchCostType(search, loading, this);
    }, 400),
    confirm() {
      if (!this.formData.DTREFECUSTO || !this.formData.costType) {
        Util.showErrorNotification({
          title: t('incomplete_data'),
          text: t('fill_in_all_fields')
        });
        return;
      }
      this.loading = true;
      RecalculateCostsController.confirmRecalcCosts(this).finally(() => {
        this.loading = false;
      });
    },
    cancel() {
      this.$emit('close');
    },
    openExistingReport() {
      if (!this.existingCustoUpdateReport) return;
      this.$modal.show(CustoUpdateReportModal, {
        report: this.existingCustoUpdateReport
      }, {
        height: 'auto',
        width: '80%',
        clickToClose: true
      });
    }
  }
};
</script>

<style scoped lang="less">
.recalculate-costs-modal {
  width: calc(100% - 30px);
  margin: 25px;

  .title {
    margin: 0 0 10px;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .data-form {
    .field {
      display: inline-block;
      margin: 10px;
      text-align: left;
      font-size: 0.9rem;
      width: calc(100% - 45px);

      input {
        padding: 5px;
        border: 1px solid #bdbdbd;
        box-sizing: border-box;
        border-radius: 4px;
        width: 100%;
        font-family: Arial;
        font-size: 0.9rem;
      }

      &.half {
        width: calc(50% - 35px);
      }

      /deep/ .v-select {
        max-width: 100%;
      }

      /deep/ .vs__dropdown-toggle {
        max-width: 100%;
      }

      /deep/ .vs__selected-options {
        min-width: 0;
        flex-wrap: nowrap;
      }

      /deep/ .vs__selected {
        display: inline-block;
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin: 15px 10px 5px;

    #open-report {
      margin-right: auto;
    }

    .ghost {
      background: white;
      color: #dc143d;
      border: 1px solid #dc143d;

      &:hover {
        color: #212146;
        border-color: #212146;
      }
    }
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    gap: 10px;

    i {
      font-size: 1.8rem;
      color: #dc143d;
    }

    p {
      margin: 0;
      color: #555;
    }
  }
}
</style>
